import { FunctionComponent } from 'react';

import NewsletterForm from 'components/content/forms/general/Newsletter';

import StyledComponent from './styles';
import { Props } from './types';

const PageRegulationsSectionNewsletter: FunctionComponent<Props> = ({ translations }) => (
    <StyledComponent className="page-regulations-section-newsletter">
        <NewsletterForm translations={{ ...translations }} />
    </StyledComponent>
);

export default PageRegulationsSectionNewsletter;
